export default "__VITE_ASSET__BoUGUzrP__"